export default __webpack_public_path__ + "static/media/widget_yellow.639f66f8.svg";